import { createSelector } from 'reselect'
import { CommonState } from '~/store/types'
import { BlockchainNetwork, CURRENCY } from '~/types'
import { BlockchainAddress } from './types'

const selectBlockchainAddressStore = (state: CommonState) => state.blockchainAddresses

export const selectBlockchainAddressList = createSelector(
  [selectBlockchainAddressStore],
  (state) => state.blockchainAddressList
)

export const selectIsBlockchainAddressesInitiated = createSelector(
  [selectBlockchainAddressStore],
  (state) => state.isBlockchainAddressListInitiated
)

export const selectFinancialInstitutionList = createSelector(
  [selectBlockchainAddressStore],
  (state) => state.fiList
)

export const selectFinancialInstitutionNameById = createSelector(
  [selectFinancialInstitutionList],
  (financialInstitutionList) => (id: number | null) => {
    const name = financialInstitutionList.find(
      (financialInstitution) => financialInstitution.id === id
    )?.name

    return name ?? 'Personal Address (Non-Custodial)'
  }
)

export const selectBlockchainAddressListByBlockchainAndCurrency = createSelector(
  [selectBlockchainAddressList],
  (blockchainAddressList) => (network: BlockchainNetwork | null, currency: CURRENCY | null) => {
    if (!network || !currency) {
      return []
    }

    return blockchainAddressList.filter(
      (b) => b.blockchain === network && b.blockchainCurrency === currency
    )
  }
)

export const selectDistinctAddressesByCurrency = createSelector(
  [selectBlockchainAddressList],
  (blockchainAddressList) => (currency: CURRENCY | null) => {
    if (!currency || blockchainAddressList.length === 0) return []

    const uniqueAddresses = new Map<string, BlockchainAddress>()

    blockchainAddressList
      .filter((address) => address.blockchainCurrency === currency)
      .forEach((address) => {
        const key = `${address.address.toLowerCase()}_${address.tag || ''}`

        if (uniqueAddresses.has(key)) return

        uniqueAddresses.set(key, address)
      })

    return Array.from(uniqueAddresses.values())
  }
)

export const selectIsWhitelistingImprovementEnabled = createSelector(
  [selectBlockchainAddressStore],
  (state) => state.isWhitelistingImprovementEnabled
)

export const selectBlockchainAddressQuota = createSelector(
  [selectBlockchainAddressStore],
  (store) => store.addressQuota
)
